import { StoreService } from '@inter-ikea-kompis/services';
import config from '../config';
export const getStores = async (serviceSettings, locale) => {
    const storeService = new StoreService({
        settings: serviceSettings,
        locale,
        dexfApiKey: config.dexfApiKey
    });
    try {
        return await storeService.getStores();
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
    }
};
export const getStoreName = (stores, storeId) => {
    return stores?.find(t => t.id === storeId)?.name;
};
//# sourceMappingURL=getStores.js.map